import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { AsyncUtils } from '@utils/AsyncUtils';

import QrScanner from 'qr-scanner';


@Component({
    selector: 'custom-camera',
    templateUrl: './camera.component.html',
    styleUrls: ['./camera.component.scss'],
})
export class CameraComponent implements OnInit, OnDestroy, OnChanges {

    @Input('overlayQRCode') OverlayQRCode: boolean = false;
    @Input('enableUI') EnableUI: boolean = false;

    @Output('callback') Callback: EventEmitter<{ text: string, blob: string, base64?: string }> = new EventEmitter();
    @Output('loaded') IsLoaded: EventEmitter<{ isAvailable?: boolean }> = new EventEmitter();

    @ViewChild('video', { static: true }) video!: ElementRef<HTMLVideoElement>;

    private videoElement: any;
    private loading: HTMLIonLoadingElement = null;


    public IsCompleted: boolean = false;

    public CameraAvailable: boolean = false;

    public TakenPhoto: boolean = false;

    private scanner?: QrScanner;

    constructor(private LoadingController: LoadingController) { }

    ngOnInit() { }

    async ngOnDestroy() {

        this.videoElement = null;

        if (this.scanner) this.scanner.destroy();
    }

    async ngOnChanges(changes: SimpleChanges) {

        console.log(changes);

    }

    async ngAfterViewInit() {


        console.log(this.OverlayQRCode, this.EnableUI);

        this.videoElement = this.video?.nativeElement;

        this.startScannerQR();
    }

    public async TakePhoto(ev?: any) {

        ev?.preventDefault();
        ev?.stopPropagation();

        await this.showLoading();

        if (this.scanner) this.scanner.stop();

        if (this.videoElement.readyState === this.videoElement.HAVE_ENOUGH_DATA) {

            this.TakenPhoto = true;

            const { url, blob, base64 } = await this.captureCanvasImage();

            if (this.loading) {
                await this.loading.dismiss();
            }

            if (this.Callback && url)
                return this.Callback.emit({ text: null, blob: url, base64: base64 })

        }
    }

    /**
     * 
     * @param ev 
     * @returns 
     */
    public CloseCamera(ev: any) {

        ev?.preventDefault();
        ev?.stopPropagation();


        if (this.scanner) this.scanner.stop();

        if (this.Callback)
            return this.Callback.emit({ text: null, blob: null, base64: null })
    }


    /**
     * NEW IMPLEMENTATION
     */
    private async startScannerQR() {

        let count = 0, maxCounts = 1;

        try {

            this.scanner = new QrScanner(
                this.videoElement,
                async (code: any) => {

                    console.log(code);

                    // delay to center and take photo
                    if (count < maxCounts) { count++; return; }

                    this.scanner?.pause();

                    this.TakenPhoto = true;

                    try {

                        await this.showLoading();

                        const { url, blob, base64 } = await this.captureCanvasImage()

                        if (this.loading)
                            await this.loading.dismiss();

                        // pára a câmera após leitura
                        this.scanner?.stop();

                        if (this.Callback)
                            return this.Callback.emit({ text: code.data, blob: url, base64 });
                    } catch (error) {
                        if (this.Callback)
                            return this.Callback.emit({ text: null, blob: null, base64: null });
                    }
                },
                {
                    // -------------------------------------------------
                    // Opções que ativam os highlights (overlay)
                    // -------------------------------------------------
                    highlightScanRegion: this.OverlayQRCode || false,      // contorno da área de varredura
                    highlightCodeOutline: true,    // contorno ao redor do QR lido
                    // opcional: limitar a câmera ao ambiente (back)
                    preferredCamera: 'environment', // 'user', 'environment'
                    // limite de scans por segundo (para economizar bateria)
                    maxScansPerSecond: 8,
                    // caso queira receber o objeto detalhado (data + corners)
                    // returnDetailedScanResult: true,
                }
            );

            this.videoElement.setAttribute('playsinline', true);

            await this.scanner?.start();

            this.CameraAvailable = true;

            if (this.IsLoaded)
                this.IsLoaded.emit({ isAvailable: true })

            this.IsCompleted = true;

        } catch (error) {

            this.CameraAvailable = false;

            if (this.IsLoaded)
                this.IsLoaded.emit({ isAvailable: false })

            this.IsCompleted = true;
        }

    }

    /**
     * 
     * @param videoEl 
     * @param type 
     * @param quality 
     * @param maxSize 
     * @returns 
     */
    private async captureCanvasImage(videoEl = this.video.nativeElement, type = 'image/jpeg', quality: number = 0.75, maxSize?: number): Promise<{ blob: Blob, url: string, base64: string }> {

        // -------------------------------------------------
        // 1️⃣ Cria o canvas e copia o frame do vídeo nele
        // -------------------------------------------------
        const canvas = document.createElement('canvas');

        const { w, h } = this.getScaledSize(videoEl, maxSize);
        canvas.width = w;
        canvas.height = h;

        const ctx = canvas.getContext('2d');
        if (!ctx) {
            throw new Error('2D context does not exist on the canvas.');
        }
        ctx.drawImage(videoEl, 0, 0, canvas.width, canvas.height);

        // -------------------------------------------------
        // 2️⃣ Base64 – já está pronto a partir do canvas
        // -------------------------------------------------
        const base64 = null;//canvas.toDataURL(type, quality);   // ex.: "data:image/jpeg;base64,/9j/…"

        // -------------------------------------------------
        // 3️⃣ Blob – converte de forma *promisificada*
        // -------------------------------------------------
        const blob: Blob = await new Promise<Blob>((resolve, reject) => {
            canvas.toBlob(b => b ? resolve(b) : reject(new Error('Blob generation failed')), type, quality);
        });

        // -------------------------------------------------
        // 4️⃣ Object‑URL – ponteiro que pode ser usado direto em <img>
        // -------------------------------------------------
        const url = URL.createObjectURL(blob);   // ex.: "blob:https://myapp.com/3f12…"

        // -------------------------------------------------
        // 5️⃣ Retorna tudo num único objeto
        // -------------------------------------------------
        return { blob, url, base64 };
    }

    /**
     * 
     * @param videoEl 
     * @param maxSize 
     * @returns 
     */
    private getScaledSize(videoEl: HTMLVideoElement, maxSize: number = 1080): { w: number; h: number } {
        const rawW = videoEl.videoWidth;
        const rawH = videoEl.videoHeight;

        // Se o vídeo já está dentro do limite, devolve as dimensões originais.
        if (rawW <= maxSize && rawH <= maxSize) {
            return { w: rawW, h: rawH };
        }

        // Qual é a maior dimensão?
        const larger = rawW > rawH ? rawW : rawH;

        // Fator de escala para que a maior dimensão vire `maxSize`.
        const scale = maxSize / larger;

        // Aplica o mesmo fator às duas dimensões e arredonda.
        const w = Math.round(rawW * scale);
        const h = Math.round(rawH * scale);
        return { w, h };
    }

    /**
     * 
     */
    private async showLoading() {

        this.loading = await this.LoadingController.create({
            cssClass: "ion-loading-default",
            // message: 'Aguarde, por favor...',
            spinner: "lines",
            mode: "ios"
        });

        await this.loading.present();
    }

}
